import { FC, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { UpdateCarLeasing } from "../../http/carLeasings/types";
import { useAdminCarsApi } from "../../http/cars/api";
import Header from "../ui/Header";
import Panel from "../ui/Panel";
import NewCarForm, { NewCarFormBody } from "./NewCarForm";

const NewCar: FC = () => {
  const navigate = useNavigate();
  const i18n = useI18n();
  const carsApi = useAdminCarsApi();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = async (form: NewCarFormBody) => {
    const param = new URLSearchParams(window.location.search);
    const carPurchaseId = param.get("car_purchase_id");

    setIsSubmitting(true);
    const leasing: UpdateCarLeasing | undefined = form.leasing?.company
      ? {
          leasingCompanyId: form.leasing.company.id,
          contractDate: form.leasing.contractDate!,
          contractDetails: form.leasing.details!,
          expirationDate: form.leasing.expirationDate!,
        }
      : undefined;

    try {
      const response = await carsApi.insertCar({
        vehicleIdentificationNumber: form.vehicleIdentificationNumber,
        plateNumber: form.plateNumber,
        driverId: form.driver?.id,
        typeOfUse: form.typeOfUse?.value,
        notes: form.notes,
        manufacturerId: form.manufacturer.id,
        model: form.model,
        hp: form.hp!,
        displacement: form.displacement,
        co2Emissions: form.co2Emissions,
        fuelType: form.fuelType?.value!,
        category: form.category?.value,
        isPrivateCar: form.isPrivateCar ?? false,
        status: form.status.value,
        subsidiaryId: form.subsidiary.id,
        carPurchaseId: carPurchaseId,
        leasing: leasing,
        registrationDate: form.registrationDate,
        purchaseDate: form.purchaseDate,
        soldDate: form.soldDate,
      });
      dispatch(showSuccessNotification(i18n.t));
      navigate(`/admin/cars/${response.id}`);
    } catch (error) {
      dispatch(showErrorNotification(i18n, error));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Header title={i18n.t.cars.new} />

      <Panel>
        <NewCarForm onSubmit={onSubmit} isDisabled={isSubmitting} />
      </Panel>
    </>
  );
};

export default NewCar;
